<div class="grid flex header-gap">
  <form [formGroup]="addAccountForm" (ngSubmit)="onAddAccountSubmit()">
    <div class="grid w-full pb-5">
      <div class="md:col-9">
        <h1 class="header">{{ 'Header.Accounts' | translate }}</h1>
        <div class="yellow-underline"></div>
      </div>
    </div>
    <div class="grid w-full pb-3">
      <div class="md:col-9">
        <h4>{{ 'Accounts.AddnewAccount' | translate }}</h4>
      </div>
    </div>

    <div class="md:col-5 p-0">
      <h6 class="mb-3">{{ 'Accounts.Mainportaluser' | translate }}</h6>
      <div class="grid w-full m-0">
        <div class="md:col-6 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <input id="firstName" formControlName="firstName" pInputText class="w-full" />
            <label for="firstName">{{ 'Accounts.FirstName' | translate }}</label>
          </p-floatlabel>
          @if (
              addAccountForm.controls.firstName.invalid &&
              (addAccountForm.controls.firstName.dirty || addAccountForm.controls.firstName.touched)
            ) {
<div
           >
            @if (addAccountForm.controls.firstName.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.FirstNameRequired' | translate }}" />
}

            @if (addAccountForm.controls.firstName.hasError('maxLengthExceeded')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.ExceedTestLimit' | translate }}" />
}

            @if (addAccountForm.controls.firstName.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.MinCharacters' | translate }}" />
}

            @if (addAccountForm.controls.firstName.hasError('invalidTextInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.AllowCharacter' | translate }}" />
}
          </div>
}
        </div>
        <div class="md:col-6 mb-2">
          <p-floatlabel class="flex flex-column">
            <input id="lastName" formControlName="lastName" pInputText class="w-full" />
            <label for="lastName">{{ 'Accounts.LastName' | translate }}</label>
          </p-floatlabel>
          @if (
              addAccountForm.controls.lastName.invalid &&
              (addAccountForm.controls.lastName.dirty || addAccountForm.controls.lastName.touched)
            ) {
<div
           >
            @if (addAccountForm.controls.lastName.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.LastNameRequired' | translate }}" />
}

            @if (addAccountForm.controls.lastName.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.MinCharacters' | translate }}" />
}

            @if (addAccountForm.controls.lastName.hasError('maxLengthExceeded')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.ExceedTestLimit' | translate }}" />
}

            @if (addAccountForm.controls.lastName.hasError('invalidTextInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.AllowCharacter' | translate }}" />
}
          </div>
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <input id="email" formControlName="email" pInputText class="w-full" />
            <label for="email">{{ 'Accounts.Email' | translate }}</label>
          </p-floatlabel>
          @if (addAccountForm.controls.email.touched && addAccountForm.controls.email.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
            icon="pi pi-info-circle"
            text="{{ 'Accounts.EmailAddressRequired' | translate }}" />
}

          @if (addAccountForm.controls.email.touched && addAccountForm.controls.email.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
            icon="pi pi-info-circle"
            text="{{ 'Accounts.InvalidEmail' | translate }}" />
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <p-select class="w-full"
              formControlName="medicalSpecialty"
              id="MedicalSpecialty"
              [options]="(medicalSpecialties$ | async) ?? []"
              optionLabel="name"
              optionValue="id"
              inputId="MedicalSpecialty" />
            <label class="input-label pl-2" for="medicalSpecialty">{{ 'Accounts.MedicalSpecialty' | translate }}</label>
          </p-floatlabel>
          @if (
              addAccountForm.controls.medicalSpecialty.touched &&
              addAccountForm.controls.medicalSpecialty.hasError('required')
            ) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
            icon="pi pi-info-circle"
            text="{{ 'Accounts.MedicalSpecialtyRequired' | translate }}" />
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <input pInputText class="w-full" formControlName="doctorId" id="doctorId" />
            <label for="doctroId">{{ 'Accounts.DoctorID' | translate }}</label>
          </p-floatlabel>
          @if (
              addAccountForm.controls.doctorId.invalid &&
              (addAccountForm.controls.doctorId.dirty || addAccountForm.controls.doctorId.touched)
            ) {
<div
           >
            @if (addAccountForm.controls.doctorId.hasError('invalidDigitCharacterInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.AllowDigitChar' | translate }}" />
}
          </div>
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <div class="flex flex-column">
            <label class="input-label pl-3" for="userRole">{{ 'Accounts.Userrole' | translate }}</label>
            <p-select formControlName="role"
              id="role"
              [options]="(roles$ | async) ?? []"
              optionLabel="name"
              optionValue="id"
              placeholder="{{ 'Accounts.UserRole' | translate }}"
              inputId="role"
              class="w-full" />
          </div>
        </div>
        <div class="md:col-12 pl-0 mb-2">
          @if (isQualifiedProfessionalVisible) {
<div class="field-checkbox">
            <p-checkbox [binary]="true"
              inputId="checkbox"
              formControlName="isQualifiedProfessional"
              class="pb-2" />
            <label for="checkbox" class="ml-2">{{ 'Accounts.Thispersonis' | translate }}</label>
          </div>
}
          @if (
              addAccountForm.controls.isQualifiedProfessional.invalid &&
              (addAccountForm.controls.isQualifiedProfessional.dirty ||
                addAccountForm.controls.isQualifiedProfessional.touched)
            ) {
<div
           >
            @if (addAccountForm.controls.isQualifiedProfessional.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.isQualifiedProfessionalRequired' | translate }}" />
}
          </div>
}
        </div>
      </div>
    </div>

    <div class="md:col-12 pl-0">
      <div class="flex justify-content-between">
        <p-button label="{{ 'Accounts.Save' | translate }}"
          styleClass="p-button-rounded"
          class="p-2 px-0"
          [disabled]="!addAccountForm.valid"
          [loading]="saveInProgress"
          type="submit" />
        <p-button label="{{ 'Accounts.Cancel' | translate }}"
          styleClass="p-button-outlined p-button-rounded"
          class="p-2 pr-0"
          (onClick)="onAddAccountCancel()" />
      </div>
    </div>
  </form>
</div>
